export const ADMIN = 'Admin';
export const STAFF = 'Staff';
export const DRIVER = 'Driver';
export const COMPLETE = 'complete';
export const ACTIVE = 'active';
export const REVIEW = 'review';
export const DRAFT = 'draft';
